module.exports = __webpack_public_path__ + "img/select.d66fb720.svg";